import React, { useState } from 'react';

const LearningStep = ({ onComplete, onBack, initialAnswers }) => {
  const [selectedLearningStyle, setSelectedLearningStyle] = useState(
    initialAnswers?.learningStyle || ''
  );

  const learningStyles = [
    {
      id: 'bold',
      emoji: '🚀',
      title: 'Dive in boldly',
      description: 'I like jumping into challenges even if I\'m not fully prepared yet'
    },
    {
      id: 'methodical',
      emoji: '📚',
      title: 'Master step-by-step',
      description: 'I prefer to build skills methodically and carefully before moving forward'
    },
    {
      id: 'collaborative',
      emoji: '👥',
      title: 'Learn through collaboration',
      description: 'I work best when learning alongside others and sharing the experience'
    },
    {
      id: 'instinctive',
      emoji: '🎯',
      title: 'Trust my instincts',
      description: 'I rely on my intuition and adapt in the moment rather than overthinking'
    }
  ];

  const handleSelectLearningStyle = (styleId) => {
    setSelectedLearningStyle(styleId);
  };

  const handleNext = () => {
    if (selectedLearningStyle) {
      onComplete({ learningStyle: selectedLearningStyle });
    }
  };

  return (
    <div className="quiz-step">
      <h2>When you're learning something new and challenging, what's your style?</h2>
      <p>Understanding how you approach growth helps us find variations that will inspire and develop your artistry.</p>
      
      <div className="options-grid">
        {learningStyles.map((style) => (
          <div
            key={style.id}
            className={`option-card ${selectedLearningStyle === style.id ? 'selected' : ''}`}
            onClick={() => handleSelectLearningStyle(style.id)}
          >
            <h3>
              <span className="emoji">{style.emoji}</span>
              {style.title}
            </h3>
            <p>{style.description}</p>
          </div>
        ))}
      </div>

      <div className="quiz-buttons">
        <button className="btn-back" onClick={onBack}>
          ← Back
        </button>
        <button 
          className="btn-next" 
          onClick={handleNext}
          disabled={!selectedLearningStyle}
        >
          Next Step →
        </button>
      </div>
    </div>
  );
};

export default LearningStep; 